/**
 * Awaits initial replication with a timeout to prevent hanging forever.
 * If the replication is canceled or times out, logs a warning and continues.
 * This prevents the app from getting stuck during initialization.
 *
 * @param replicationState - The RxDB replication state
 * @param collectionName - Name of the collection for logging
 * @param timeoutMs - Timeout in milliseconds (default: 30000ms = 30 seconds)
 */
export async function awaitInitialReplicationWithTimeout(
  replicationState: any,
  _collectionName: string,
  timeoutMs: number = 30000,
): Promise<void> {
  try {
    const timeout = new Promise<never>((_, reject) =>
      setTimeout(() => reject(new Error('Initial replication timeout')), timeoutMs)
    )
    await Promise.race([replicationState.awaitInitialReplication(), timeout])
  } catch (error) {
    // Error handling
  }
}
